$(document).ready(function () {
    $("select.select_chosen_with_color_support").chosen({
        no_results_text: "Ingen tags funnet!",
        width: "100%",
    });

    addColorToSelectedElementsOnEverySelect();
    renumberOnEverySelect(); // initial numbering where applicable

    /**
     * Event when the dropdown is displayed
     * The color of each option (li) is fetched from "tag-color" attribute of the select -> option tag
     **/
    $(document).on('chosen:showing_dropdown', 'select.select_chosen_with_color_support', function () {
        addColorsToDropdownList($(this));
    });

    /**
     * When searching for tag, add colors to matching tags
     **/
    $(document).on('keyup', 'input.chosen-search-input', function () {
        let selectParent = $(this).parent().parent().parent().parent();
        let select = $('select.select_chosen_with_color_support', selectParent);
        addColorsToDropdownList(select);
    });

    /**
     * When searching for tag, add colors to matching tags
     **/
    $(document).on('keyup', 'div.chosen-container div.chosen-search input ', function () {
        let selectParent = $(this).parent().parent().parent().parent().parent();
        let select = $('select.select_chosen_with_color_support', selectParent);
        addColorsToDropdownList(select);
    });

    /**
     * Event when the dropdown is initialized
     * Function to add colors to already selected options is called
     **/
    $(document).on('chosen:ready', 'select.select_chosen_with_color_support', function () {
        addColorsOnSelectedOptions($(this));
        renumberSelectedOptions($(this)); // handle numbered_selection on init
    });

    /**
     * Chosen refreshes its DOM on update; keep colors and numbers in sync
     **/
    $(document).on('chosen:updated', 'select.select_chosen_with_color_support', function() {
        addColorsOnSelectedOptions($(this));
        addColorsToDropdownList($(this));
        renumberSelectedOptions($(this));
    });

    /**
     * Event when an option is selected/deselected
     * Append color to the selected value and renumber if needed
     **/
    $(document).on('change', 'select.select_chosen_with_color_support', function () {
        addColorsOnSelectedOptions($(this));
        addColorsToDropdownList($(this)); // for ctrl/shift multi actions
        // Defer so DOM reflects the removal before we renumber
        const sel = $(this);
        setTimeout(function(){ renumberSelectedOptions(sel); }, 400);
    });

    $(document).on('click', 'div.chosen-container-multi .search-choice-close', function() {
        const $chosen = $(this).closest('div.chosen-container');
        const selectId = $chosen.attr('id').replace('_chosen', '');
        const $select = $('#' + selectId);
        if ($select.hasClass('numbered_selection')) {
            // Run after Chosen updates its DOM
            setTimeout(function(){ renumberSelectedOptions($select); }, 400);
        }
        addColorsToDropdownList($(this)); // for ctrl/shift multi actions
        renumberSelectedOptions($(this)); // maintain 1., 2., 3. prefixes
    });

    function addColorsToDropdownList(select) {
        let id = select.attr('id');
        let selectBoxChosenId = id + '_chosen';

        $('div#' + selectBoxChosenId + ' ul.chosen-results li').each(function () {
            // Find corresponding <option> tag
            let index = $(this).attr('data-option-array-index');
            let color = $('select#' + id + ' option:eq(' + index + ')').attr('tag-color');

            if (color != null) {
                // Avoid duplicating the color dot
                if (!$(this).find('.color_display').length) {
                    let colorSpan = '<span class="color_display" style="background-color:' + color + ';"></span>';
                    $(this).prepend(colorSpan);
                }
            }
        });
    }

    function addColorsOnSelectedOptions(select) {
        let id = select.attr('id');
        let selectBoxChosenId = id + '_chosen';

        // Find the chosen box which contains the selected options
        let chosenContainer = $('div#' + selectBoxChosenId);

        // Single selected option
        if (chosenContainer.hasClass('chosen-container-single')) {
            addColorToSelectedOptionSingle(chosenContainer, id);

            // Multiple selected options
        } else if (chosenContainer.hasClass('chosen-container-multi')) {
            // Iterate each selected option in this chosen and find the one missing color info
            $('ul.chosen-choices li.search-choice', chosenContainer).each(function () {
                addColorToSelectedOptionMulti(id, $(this));
            });
        }
    }

    function addColorToSelectedOptionMulti(selectId, optionElement) {
        if (!optionElement.find('.color_display_small').length) {
            // Span with color info does not exist yet, create it
            let dropdownOptionIndex = $('a', optionElement).attr('data-option-array-index');

            let color = $('select#' + selectId + ' option:eq(' + dropdownOptionIndex + ')').attr('tag-color');

            if (color != null) {
                let colorSpan = '<span class="color_display_small" style="background-color:' + color + ';"></span>';
                optionElement.prepend(colorSpan);
            }
        } else {
            // color info already exist
        }
    }

    function addColorToSelectedOptionSingle(chosenContainer, selectId) {
        let selectedChosenOption = chosenContainer.find('a.chosen-single');
        let colorDot = selectedChosenOption.find('.color_display_small');
        if (colorDot.length) {
            colorDot.remove();
        }

        let selectedElement = $('option:selected', $('select#' + selectId));
        let color = selectedElement.attr('tag-color');

        if (color != null) {
            let colorSpan = '<span class="color_display_small" style="background-color:' + color + ';"></span>';
            selectedChosenOption.prepend(colorSpan);
        }
    }

    function addColorToSelectedElementsOnEverySelect() {
        $('div.chosen-container').each(function () {
            let chosenElementId = $(this).attr('id');
            let selectElementId = chosenElementId.replace("_chosen", "");
            addColorsOnSelectedOptions($('select#' + selectElementId));
        });
    }

    /**
     * Numbering for multiselects with class "numbered_selection"
     * - Prefix the visible label with "1. ", "2. ", ...
     * - Recalculate on any change/update/remove
     * - Preserve the original label in a data attribute to avoid stacking prefixes
     */
    function renumberSelectedOptions(select) {
        if (!select.hasClass('numbered_selection')) return;

        let id = select.attr('id');
        let chosenContainer = $('#' + id + '_chosen');
        if (!chosenContainer.hasClass('chosen-container-multi')) return;

        let i = 1;
        $('ul.chosen-choices li.search-choice', chosenContainer).each(function(){
            // The visible label is the first span that is NOT the color dot
            let $li = $(this);
            let $labelSpan = $('span', $li).not('.color_display_small').first();

            // Store base/original label once
            if (!$li.data('base-label')) {
                // If numbers already exist (e.g., after a refresh), strip "N. " just in case
                let rawText = $labelSpan.text();
                let base = rawText.replace(/^\s*\d+\.\s*/, '').trim();
                $li.data('base-label', base);
            }

            let baseLabel = $li.data('base-label') || $labelSpan.text();
            $labelSpan.text(i + '. ' + baseLabel);
            i++;
        });
    }

    function renumberOnEverySelect() {
        $('select.select_chosen_with_color_support.numbered_selection').each(function(){
            renumberSelectedOptions($(this));
        });
    }
});
function toggleFilters() {
    const filterOptions = document.getElementById('filter_options_wrapper');
    const toggleText = document.getElementById('filter_toggle_text');
    const toggleIcon = document.getElementById('filter_toggle_icon');

    if (filterOptions.style.display === 'none') {
        filterOptions.style.display = 'block';
        toggleText.textContent = 'Hide Filters';
        toggleIcon.textContent = '-';
    } else {
        filterOptions.style.display = 'none';
        toggleText.textContent = 'Show Filters';
        toggleIcon.textContent = '+';
    }
}